import { render, staticRenderFns } from "./r-simple-list-item.vue?vue&type=template&id=03deebec&"
import script from "./r-simple-list-item.vue?vue&type=script&lang=js&"
export * from "./r-simple-list-item.vue?vue&type=script&lang=js&"
import style0 from "./r-simple-list-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports